export const MANUAL_IDENTITY_TEST_ID: string = "manual-identity-fallback";

export const EMPLOYEE_REGISTRY_PANEL_TEST_ID: string = "employee-registry-panel";

export const EMPLOYMENT_ACK_TEST_ID: string = "manual-identity-ack";

export const DECISION_REASON_TEST_ID: string = "decision-reason";

export const CLASSIFICATION_BADGE_TEST_ID: string = "classification-badge";
